import { configureStore, createSlice, createListenerMiddleware } from "@reduxjs/toolkit";
import { formatTimestamp, clamp } from "/src/utilities";
import { pokemonConst } from "./pokemonConst";
import { searchAPI, showAllAPI } from "./pokemonSource";
import { act } from "react";
import { stripTeam } from "/src/objectStripper";
import { initializePokemon } from "./utilities";

const teamMaxSize = 6; const maxEV = 252; const maxIV = 31;
const maxBoost = 6; const minBoost = -6; const maxLevel = 100;
const initialState = {

    //Team
    team: [],
    currentPokemonName: null, 

    //MUI
    open: false,
    natureOpen: false,
    loading: false,

    //Promise-stuff
    showPokemonPromiseState: { promise: null, data: [], error: null },
    showMovesPromiseState: { promise: null, data: [], error: null },
    showItemsPromiseState: { promise: null, data: [], error: null },
    showAbilitiesPromiseState: { promise: null, data: [], error: null },
    showNaturesPromiseState: { promise: null, data: [], error: null },

    abilityInfo: null,

    //Persistance
    hello: "hello",
    user: undefined,
    ready: false,

    //Authentication
    currentEmail: null,
    currentPassword: null,
    authError: null,

    // Damage calculator
    damageAttackerName: "",
    damageDefenderName: "",
    damageMoveName: "",
    damageIsCrit: false,

    // Attacker details
    attackerCurrentHP: null,
    attackerLevel: 50,
    attackerGender: "N",
    attackerAbility: "",
    attackerItem: "",
    attackerNature: "",
    attackerStatus: "",
    attackerTeraType: "",
    attackerIsTerastallized: false,
    attackerType1Override: "",
    attackerType2Override: "",
    attackerEVs: { hp: 0, atk: 0, def: 0, spa: 0, spd: 0, spe: 0 },
    attackerIVs: { hp: maxIV, atk: maxIV, def: maxIV, spa: maxIV, spd: maxIV, spe: maxIV },
    attackerBoosts: { atk: 0, def: 0, spa: 0, spd: 0, spe: 0 },

    //Defender Details
    defenderCurrentHP: null,
    defenderLevel: 50,
    defenderGender: "N",
    defenderAbility: "",
    defenderItem: "",
    defenderNature: "",
    defenderStatus: "",
    defenderTeraType: "",
    defenderIsTerastallized: false,
    defenderType1Override: "",
    defenderType2Override: "",
    defenderEVs: { hp: 0, atk: 0, def: 0, spa: 0, spd: 0, spe: 0 },
    defenderIVs: { hp: maxIV, atk: maxIV, def: maxIV, spa: maxIV, spd: maxIV, spe: maxIV },
    defenderBoosts: { atk: 0, def: 0, spa: 0, spd: 0, spe: 0 },

    //Field
    damageTerrain: "",
    damageWeather: "",
    damageGameType: "Singles", // 'Singles' | 'Doubles'
    damageMagicRoom: false,
    damageWonderRoom: false,
    damageGravity: false,
    damageSoR: false,
    damageBoR: false,
    damageToR: false,
    damageVoR: false,
    //Attacker
    attackerHelpingHand: false,
    attackerTailwind: false,
    attackerFlowerGift: false,
    attackerPowerTrick: false,
    damageSteelySpirit: false,
    damagePowerSpot: false,
    damageBattery: false,
    //Defender
    defenderHelpingHand: false,
    defenderTailwind: false,
    defenderFlowerGift: false,
    defenderPowerTrick: false,
    damageReflect: false,
    damageLightScreen: false,
    damageFriendGuard: false,
    damageSR: false,
    damageSpikes: 0,
    damageProtected: false,
    damageSeeded: false,
    damageSaltCure: false,
    damageForesight: false,
    
    damageResult: null,
    damageError: null,  
};

const pokeSlice = createSlice({
    name: "poke",
    initialState: initialState,
    reducers: {
        
        //Team
        addToTeam(state, action){
            const pokemon = action.payload;
            if (!pokemon) return;
            if (state.team.some(p => p?.id === pokemon?.id)){ console.log(pokemon), "Already in team  "; return;}
            if (state.team.length < teamMaxSize) {
                state.team = [...state.team, initializePokemon(pokemon)];
            }
        },
        addActualMove(state, action){
            const moveName = action.payload.moveName;
            const pokemonIndex = action.payload.pokemonIndex;
            const slot =action.payload.slot
            if (pokemonIndex === -1) return;
            const moveIndex = state.team[pokemonIndex].moves.findIndex(function findCB(moves){ return moves.move.name === moveName; });
            state.team[pokemonIndex].actualMoves[slot] = state.team[pokemonIndex].moves[moveIndex];
        },
        addMoveInfo(state, action){
            const results = action.payload.results;
            const pokemonIndex = action.payload.index;
            const slot = action.payload.slot;
            if (pokemonIndex === -1) return;
            state.team[pokemonIndex].moveInfo[slot] = results;
        },
        removeMove(state, action){
            const { pokemonIndex, slot } = action.payload;

            if (pokemonIndex === -1) return;

            state.team[pokemonIndex].actualMoves[slot] = null;

            state.team[pokemonIndex].moveInfo[slot] = null;
        },
        removeFromTeam(state,action){
            function keepPokemonCB(pokemon){
                return pokemon?.id !== action.payload.id;
            }
            state.team = state.team.filter(keepPokemonCB);
        },
        setCurrentPokemon(state,action){state.currentPokemonName = action.payload;},

        //Detail
        addActualMove(state, action){
            const moveName = action.payload.moveName;
            const pokemonIndex = action.payload.pokemonIndex;
            const slot =action.payload.slot
            if (pokemonIndex < 0 || pokemonIndex >= state.team.length) return;
            const moveIndex = state.team[pokemonIndex].moves.findIndex(function findCB(moves){ return moves.move.name === moveName; });
            state.team[pokemonIndex].actualMoves[slot] = state.team[pokemonIndex].moves[moveIndex];
        },
        addMoveInfo(state, action){
            const results = action.payload.results;
            const pokemonIndex = action.payload.index;
            const slot = action.payload.slot;
            if (pokemonIndex < 0 || pokemonIndex >= state.team.length) return;
            state.team[pokemonIndex].moveInfo[slot] = results;
        },
        setLevel(state, action){
            const pokemonIndex = action.payload.pokemonIndex;
            if (pokemonIndex < 0 || pokemonIndex >= state.team.length) return;
            const level = action.payload.level;
            state.team[pokemonIndex].level = level;
        },
        setEVstat(state, action){ 
            const pokemonIndex = action.payload.pokemonIndex;
            const statName = action.payload.statName;
            const newValue = action.payload.newValue;

            if (pokemonIndex < 0 || pokemonIndex >= state.team.length) return;
                const statIndex = state.team[pokemonIndex].stats.findIndex(function findCB(stats){ 
                    return stats.stat.name === statName; });
            if (statIndex !== -1) {
                const value = newValue;
                state.team[pokemonIndex].stats[statIndex].EV_Value = value;
            }
        },
        setIVstat(state, action){
            const pokemonIndex = action.payload.pokemonIndex;
            const statName = action.payload.statName;
            const newValue = action.payload.newValue;
            if (pokemonIndex < 0 || pokemonIndex >= state.team.length) return;
            const statIndex = state.team[pokemonIndex].stats.findIndex(function findCB(stats){
                return stats.stat.name === statName; });
            if (statIndex !== -1) {
                state.team[pokemonIndex].stats[statIndex].IV_Value = newValue;
            }
        },
        setNature(state, action){
            const results = action.payload.results;
            const pokemonIndex = action.payload.index;
            if (pokemonIndex < 0 || pokemonIndex >= state.team.length) return;
            const decrease = results.decreased_stat?.name;
            const increase = results.increased_stat?.name;
            const minusIndex = state.team[pokemonIndex].stats.findIndex(function findCB(stats){return decrease === stats.stat.name});
            const plusIndex = state.team[pokemonIndex].stats.findIndex(function findCB(stats){return increase === stats.stat.name});
            state.team[pokemonIndex].stats = state.team[pokemonIndex].stats.map(s => ({ ...s, natureModifier: 1 }));
            if(!decrease&&!increase){
                const natureInfo = {name:results.name,decrease:"none",increase:"none"}
                 state.team[pokemonIndex].natureInfo = natureInfo;
                return;
            }

            const natureInfo = {name:results.name,decrease:decrease,increase:increase}
            state.team[pokemonIndex].stats[plusIndex].natureModifier=1.1;
            state.team[pokemonIndex].stats[minusIndex].natureModifier=0.9;  
            state.team[pokemonIndex].natureInfo = natureInfo;
        },
        setAbility(state, action){
            const results = action.payload.results;
            const pokemonIndex = action.payload.index;
            const abilityName = results.name;

            if (pokemonIndex < 0 || pokemonIndex >= state.team.length) return;
            state.team[pokemonIndex].abilities.forEach(function resetChosenCB(abilities){ 
                abilities.chosen = false; });
            const abilityIndex = state.team[pokemonIndex].abilities.findIndex(function findCB(abilities){ 
                return abilities.ability.name === abilityName; });
            state.team[pokemonIndex].abilities[abilityIndex].chosen = true;
            state.team[pokemonIndex].abilities[abilityIndex].description = results.effect_entries.find(entry =>
                                                                            entry.language.name === "en")?.effect || "";
            state.team[pokemonIndex].abilityInfo = {
                name: abilityName,
                description: results.effect_entries.find(e => e.language.name === "en")?.effect || ""
            };
        },
        removeAbility(state, action){
            const pokemonIndex = action.payload;

            if (
                typeof pokemonIndex !== "number" ||
                pokemonIndex < 0 ||
                pokemonIndex >= state.team.length
            ) {
                return;
            }

            state.team[pokemonIndex].abilities.forEach(ab => ab.chosen = false);
            state.team[pokemonIndex].abilityInfo = null;
        },
        setItem(state, action){
            const results = action.payload.results;
            const pokemonIndex = action.payload.index;
            if (pokemonIndex < 0 || pokemonIndex >= state.team.length) return;
            state.team[pokemonIndex].held_item = results;
        },

        //MUI
        setNatureOpen(state, action){state.natureOpen = action.payload;},
        setOpen(state, action) {state.open = action.payload;},
        setOptions(state, action) {state.showPokemonPromiseState.data = action.payload;},

        //Search + Promise
        showPokemon(state, action) {state.showPokemonPromiseState = { promise: null, data: [], error: null }; },
        showMoves(state) { state.showMovesPromiseState = { promise: null, data: [], error: null }; },
        showItems(state) { state.showItemsPromiseState = { promise: null, data: [], error: null }; },
        showAbilities(state) { state.showAbilitiesPromiseState = { promise: null, data: [], error: null }; },
        showNatures(state){ state.showNaturesPromiseState = { promise: null, data: [], error: null }; },
        //Moves
        movesStarted(state, action) { state.showMovesPromiseState.promise = action.payload; state.showMovesPromiseState.data = []; state.showMovesPromiseState.error = null; },
        movesResolved(state, action) { const { promise, data } = action.payload; if (state.showMovesPromiseState.promise !== promise) return; state.showMovesPromiseState.data = data; },
        movesRejected(state, action) { const { promise, error } = action.payload; if (state.showMovesPromiseState.promise !== promise) return; state.showMovesPromiseState.error = error; },

        //Items
        itemsStarted(state, action) { state.showItemsPromiseState.promise = action.payload; state.showItemsPromiseState.data = []; state.showItemsPromiseState.error = null; },
        itemsResolved(state, action) { const { promise, data } = action.payload; if (state.showItemsPromiseState.promise !== promise) return; state.showItemsPromiseState.data = data; },
        itemsRejected(state, action) { const { promise, error } = action.payload; if (state.showItemsPromiseState.promise !== promise) return; state.showItemsPromiseState.error = error; },

        //Abilities
        abilitiesStarted(state, action) { state.showAbilitiesPromiseState.promise = action.payload; state.showAbilitiesPromiseState.data = []; state.showAbilitiesPromiseState.error = null; },
        abilitiesResolved(state, action) { const { promise, data } = action.payload; if (state.showAbilitiesPromiseState.promise !== promise) return; state.showAbilitiesPromiseState.data = data; },
        abilitiesRejected(state, action) { const { promise, error } = action.payload; if (state.showAbilitiesPromiseState.promise !== promise) return; state.showAbilitiesPromiseState.error = error; },

        //Natures
        naturesStarted(state, action) { state.showNaturesPromiseState.promise = action.payload; state.showNaturesPromiseState.data = []; state.showNaturesPromiseState.error = null; },
        naturesResolved(state, action) { const { promise, data } = action.payload; if (state.showNaturesPromiseState.promise !== promise) return; state.showNaturesPromiseState.data = data; },
        naturesRejected(state, action) { const { promise, error } = action.payload; if (state.showNaturesPromiseState.promise !== promise) return; state.showNaturesPromiseState.error = error; },

        //Authentication
        setCurrentEmail(state, action){state.currentEmail = action.payload;},
        setCurrentPassword(state, action){state.currentPassword = action.payload;},
        setAuthError(state, action) {state.authError = action.payload;},

        // Damage calculator
        setDamageAttackerName(state, action) { state.damageAttackerName = action.payload; },
        setDamageDefenderName(state, action) { state.damageDefenderName = action.payload; },
        setDamageMoveName(state, action) { state.damageMoveName = action.payload; },
        setDamageIsCrit(state, action) { state.damageIsCrit = action.payload; },
        setDamageGameType(state, action) { state.damageGameType = action.payload; },

        // Attacker details
        setAttackerCurrentHP(state, action) { state.attackerCurrentHP = clamp(action.payload, 0, 9999); },
        setAttackerLevel(state, action) { state.attackerLevel = clamp(action.payload, 1, maxLevel); },
        setAttackerGender(state, action) { state.attackerGender = action.payload; },
        setAttackerAbility(state, action) { state.attackerAbility = action.payload; },
        setAttackerItem(state, action) { state.attackerItem = action.payload; },
        setAttackerNature(state, action) { state.attackerNature = action.payload; },
        setAttackerStatus(state, action) { state.attackerStatus = action.payload; },
        setAttackerTeraType(state, action) { state.attackerTeraType = action.payload; },
        setAttackerTerastallized(state, action) { state.attackerIsTerastallized = action.payload; },
        setAttackerType1Override(state, action) { state.attackerType1Override = action.payload; },
        setAttackerType2Override(state, action) { state.attackerType2Override = action.payload; },
        
        setAttackerEV(state, action) {
            const { stat, value } = action.payload;
            if (state.attackerEVs[stat] === undefined) return;
            state.attackerEVs[stat] = clamp(value, 0, maxEV);
        },
        
        setAttackerIV(state, action) {
            const { stat, value } = action.payload;
            if (state.attackerIVs[stat] === undefined) return;
            state.attackerIVs[stat] = clamp(value, 0, maxIV);
        },
        
        setAttackerBoost(state, action) {
            const { stat, value } = action.payload;
            if (state.attackerBoosts[stat] === undefined) return;
            state.attackerBoosts[stat] = clamp(value, minBoost, maxBoost);
        },
        
        //Defender Details
        setDefenderCurrentHP(state, action) { state.defenderCurrentHP = clamp(action.payload, 0, 9999); },
        setDefenderLevel(state, action) { state.defenderLevel = clamp(action.payload, 1, maxLevel); },
        setDefenderGender(state, action) { state.defenderGender = action.payload; },
        setDefenderAbility(state, action) { state.defenderAbility = action.payload; },
        setDefenderItem(state, action) { state.defenderItem = action.payload; },
        setDefenderNature(state, action) { state.defenderNature = action.payload; },
        setDefenderStatus(state, action) { state.defenderStatus = action.payload; },
        setDefenderTeraType(state, action) { state.defenderTeraType = action.payload; },
        setDefenderTerastallized(state, action) { state.defenderIsTerastallized = action.payload; },
        setDefenderType1Override(state, action) { state.defenderType1Override = action.payload; },
        setDefenderType2Override(state, action) { state.defenderType2Override = action.payload; },
        
        setDefenderEV(state, action) {
            const { stat, value } = action.payload;
            if (state.defenderEVs[stat] === undefined) return;
            state.defenderEVs[stat] = clamp(value, 0, maxEV);
        },
        
        setDefenderIV(state, action) {
            const { stat, value } = action.payload;
            if (state.defenderIVs[stat] === undefined) return;
            state.defenderIVs[stat] = clamp(value, 0, maxIV);
        },
        
        setDefenderBoost(state, action) {
            const { stat, value } = action.payload;
            if (state.defenderBoosts[stat] === undefined) return;
            state.defenderBoosts[stat] = clamp(value, minBoost, maxBoost);
        },
        
        //Field
        setDamageTerrain(state, action) { state.damageTerrain = action.payload; },
        setDamageWeather(state, action) { state.damageWeather = action.payload; },
        setDamageMR(state, action) { state.damageMagicRoom = action.payload; }, 
        setDamageWR(state, action) { state.damageWonderRoom = action.payload; },
        setDamageGravity(state, action) { state.damageGravity = action.payload; },
        setDamageSoR(state, action) { state.damageSoR = action.payload; },
        setDamageBoR(state, action) { state.damageBoR = action.payload; },
        setDamageToR(state, action) { state.damageToR = action.payload; },
        setDamageVoR(state, action) { state.damageVoR = action.payload; },
        
        //Atacker
        setAttackerHH(state, action) { state.attackerHelpingHand = action.payload; },
        setAttackerTailwind(state, action) { state.attackerTailwind = action.payload; },
        setAttackerFG(state, action) { state.attackerFlowerGift = action.payload; },
        setAttackerPT(state, action) { state.attackerPowerTrick = action.payload; },
        setAttackerSS(state, action) { state.damageSteelySpirit = action.payload; },
        setAttackerPS(state, action) { state.damagePowerSpot = action.payload; },
        setAttackerBattery(state, action) { state.damageBattery = action.payload; },
        
        //Defender
        setDefenderHH(state, action) { state.defenderHelpingHand = action.payload; },
        setDefenderTailwind(state, action) { state.defenderTailwind = action.payload; },
        setDefenderFG(state, action) { state.defenderFlowerGift = action.payload; },
        setDefenderPT(state, action) { state.defenderPowerTrick = action.payload; },
        setDamageReflect(state, action) { state.damageReflect = action.payload; },
        setDamageLightScreen(state, action) { state.damageLightScreen = action.payload; },
        setDamageFriendGuard(state, action) { state.damageFriendGuard = action.payload; },
        setDamageSR(state, action) { state.damageSR = action.payload; },
        setDamageSpikes(state, action) { state.damageSpikes = action.payload; },
        setDamageProtected(state, action) { state.damageProtected = action.payload; },
        setDamageSeeded(state, action) { state.damageSeeded = action.payload; },
        setDamageSaltCure(state, action) { state.damageSaltCure = action.payload; },
        setDamageForesight(state, action) { state.damageForesight = action.payload; },
        setDamageResult(state, action) { state.damageResult = action.payload; },
        setDamageError(state, action) { state.damageError = action.payload; },

        //Just for persistence
        setUser(state, action) { state.user = action.payload; },
        setReady(state, action) { state.ready = action.payload; },
        setTeam(state, action) { state.team = action.payload; },
        clearTeam(state) { state.team = []; },

        
        fillFirestore(state, action) {
            //(devComment) Lägg till flera variabler ifall fler sakker ska pushas till FireStore
            const hello = action.payload;
            state.hello = hello;
        },

        //just for middleware
        searchStarted(state, action) {
            const promise = action.payload;
            state.searchResultsPromiseState.promise = promise;
            state.searchResultsPromiseState.data = null;
            state.searchResultsPromiseState.error = null;
        },

        searchResolved(state, action) {
            const {promise, data} = action.payload;
            if (state.searchResultsPromiseState.promise !== promise) return;
            state.searchResultsPromiseState.data = data;
        },

        searchRejected(state, action) {
            const {promise, error} = action.payload;
            if (state.searchResultsPromiseState.promise !== promise) return;
            state.searchResultsPromiseState.error = error;
        },

        showStarted(state, action) {
            const promise = action.payload;
            state.showPokemonPromiseState.promise = promise;
            state.showPokemonPromiseState.data = [];
            state.showPokemonPromiseState.error = null;
            state.loading = true;
        },

        showResolved(state, action) {
            const {promise, data} = action.payload;
            if (state.showPokemonPromiseState.promise !== promise) return;
            state.showPokemonPromiseState.data = data;
            state.loading = false;
        },

        showRejected(state, action) {
            const {promise, error} = action.payload;
            if (state.showPokemonPromiseState.promise !== promise) return;
            state.showPokemonPromiseState.error = error;
            state.loading = false;
        },
    }
});

export const {
    //Team
    addToTeam,
    removeFromTeam,
    setCurrentPokemon,
    //Detail
    addActualMove,
    addMoveInfo,
    removeMove,
    setAbility,
    removeAbility,
    setItem,
    setLevel,
    setIVstat,
    setEVstat,
    setNature,
    //Search
    showPokemon,
    setOpen,
    setNatureOpen,

    //Promises + Search
    showMoves, 
    showItems, 
    showAbilities,
    showNatures,

    showStarted, showResolved, showRejected,
    movesStarted, movesResolved, movesRejected,
    itemsStarted, itemsResolved, itemsRejected,
    abilitiesStarted, abilitiesResolved, abilitiesRejected,
    naturesStarted, naturesResolved, naturesRejected,
    searchStarted, searchResolved, searchRejected,

    //Persistence
    setUser,
    setReady,
    fillFirestore,
    setCurrentEmail,
    setCurrentPassword,
    setAuthError,
    setTeam,
    clearTeam,

    // Damage calculator
    setDamageAttackerName,
    setDamageDefenderName,
    setDamageMoveName,
    setDamageIsCrit,
    setDamageGameType,
    
    //Attack details
    setAttackerCurrentHP,
    setAttackerLevel,
    setAttackerGender,
    setAttackerAbility,
    setAttackerItem,
    setAttackerNature,
    setAttackerStatus,
    setAttackerTeraType,
    setAttackerTerastallized,
    setAttackerType1Override,
    setAttackerType2Override,
    setAttackerEV,
    setAttackerIV,
    setAttackerBoost,

    //Defender details
    setDefenderCurrentHP,
    setDefenderLevel,
    setDefenderGender,
    setDefenderAbility,
    setDefenderItem,
    setDefenderNature,
    setDefenderStatus,
    setDefenderTeraType,
    setDefenderTerastallized,
    setDefenderType1Override,
    setDefenderType2Override,
    setDefenderEV,
    setDefenderIV,
    setDefenderBoost,
    
    //Field
    setDamageTerrain,
    setDamageWeather,
    setDamageMR,
    setDamageWR,
    setDamageGravity,
    setDamageReflect,
    setDamageSoR,
    setDamageBoR,
    setDamageToR,
    setDamageVoR,

    //Attacker
    setAttackerHH,
    setAttackerTailwind,
    setAttackerFG,
    setAttackerPT,
    setAttackerSS,
    setAttackerPS,
    setAttackerBattery,

    //Defender
    setDefenderHH,
    setDefenderTailwind,
    setDefenderFG,
    setDefenderPT,
    setDamageLightScreen,
    setDamageResult,
    setDamageFriendGuard,
    setDamageSR,
    setDamageSpikes,
    setDamageProtected,
    setDamageSeeded,
    setDamageSaltCure,
    setDamageForesight,

    setDamageError,
} = pokeSlice.actions;

// ---------- //
// Chat stuff //
// ---------- //

const chatInitialState = {
    sessionId: null,
    sessionName: "",
    timeStamp: null,
    includeTeam: true,
    messages: [],
    preparedPrompts: [
        {
            context: "teamView", 
            query: "What's the biggest weakness in my team?",
            append: "team"},
        {
            context: "teamView", 
            query: "How can I improve my team?",
            append: "team"},
        {
            context: "detailsView", 
            query: "How can I improve this pokemon?",
            append: "pokemon"}
    ],
    context: null,
    loading: false,
    windowOpen: true,
    error: null
};

const chatSlice = createSlice({
    name: "chat",
    initialState: chatInitialState,
    reducers: {
        setIncludeTeam(state, action){
            state.includeTeam = action.payload;
        },
        setChatContext(state, action) {
            state.context = action.payload;
        },
        promptStart(state, action) {

            const query = action.payload;

            state.loading = true;
            state.error = null;
            
            state.messages.push({
                id: Date.now(),
                role: "user",
                content: query,
                timestamp: new Date().toISOString()
            });

            if (!state.timeStamp) {
                state.timeStamp = formatTimestamp(new Date());
                state.sessionId = 0; // TODO: Fix id generator
                state.sessionName = query;
            }
        },
        promptSuccess(state, action) {
            state.loading = false;
            
            const responseText = 
                action.payload?.choices?.[0]?.message?.content ?? "[Empty response]";

            state.messages.push({
                id: Date.now() + 1,
                role: "assistant",
                content: responseText,
                timestamp: new Date().toISOString()
            });
        },
        promptError(state, action) {
            state.loading = false;
            state.error = action.payload;
        },
        toggleChatWindow(state) {
            state.windowOpen = !state.windowOpen;
        },
        resetChat(state) {
            state.messages = [];
            state.loading = false;
            state.error = null;
            state.includeTeam = true;
        }
    }
})

export const {
    setIncludeTeam,
    setChatContext,
    promptStart,
    promptSuccess,
    promptError,
    toggleChatWindow,
    resetChat
} = chatSlice.actions;

const listenerMiddleware = createListenerMiddleware();

export const store = configureStore({
    reducer: {
        poke: pokeSlice.reducer,
        chat: chatSlice.reducer
    },
    // optional: add a middleware
    middleware(getDefaultMiddleware){
    return getDefaultMiddleware({serializableCheck: {
        ignoredActionPaths: ['payload'],
        ignoredPaths: ['poke']}}).prepend(listenerMiddleware.middleware)
    }, 
});


listenerMiddleware.startListening(
{
    type: 'poke/showPokemon',
    effect(action, store){
        const promise = showAllAPI("pokemon");
        store.dispatch(showStarted(promise))

        if (!promise) return;
        promise
            .then((data) => {store.dispatch(showResolved({promise,data}));})
            .catch((error) => {store.dispatch(showRejected({promise,error}));})
    }
})

listenerMiddleware.startListening({
    type: "poke/showMoves",
    effect(action, store) {

        const promise = showAllAPI("move");
        store.dispatch(movesStarted(promise));

        if (!promise) return;

        promise
            .then((data) => store.dispatch(movesResolved({ promise, data })))
            .catch((error) => store.dispatch(movesRejected({ promise, error })));
    },
});

listenerMiddleware.startListening({
    type: "poke/showItems",
    effect(action, store) {
        const promise = showAllAPI("item");
        store.dispatch(itemsStarted(promise));

        if (!promise) return;

        promise
            .then((data) => store.dispatch(itemsResolved({ promise, data })))
            .catch((error) => store.dispatch(itemsRejected({ promise, error })));
    },
});

listenerMiddleware.startListening({
    type: "poke/showAbilities",
    effect(action, store) {
        const promise = showAllAPI("ability");
        store.dispatch(abilitiesStarted(promise));

        if (!promise) return;
        
        promise
            .then((data) => store.dispatch(abilitiesResolved({ promise, data })))
            .catch((error) => store.dispatch(abilitiesRejected({ promise, error })));
    },
});

listenerMiddleware.startListening({
    type: "poke/showNatures",
    effect(action, store) {
        const promise = showAllAPI("nature");
        store.dispatch(naturesStarted(promise));

        if (!promise) return;
        
        promise
            .then((data) => store.dispatch(naturesResolved({ promise, data })))
            .catch((error) => store.dispatch(naturesRejected({ promise, error })));
    },
});